import React from 'react'
import { useComputed } from '@preact/signals-react'
import { formData } from '@signals'

import { AppAsyncOfficesAutocomplete } from '@components'
import { useAppFormHandler } from '@hooks'


export default function OfficeSelector() {

	const { idOffices, onIdOfficesChange } = useAppFormHandler('idOffices')
	const mustHide = useComputed(() => !formData.value?.isCheckedOffice)

	if (mustHide.value) return null

	return <AppAsyncOfficesAutocomplete
		multiple
		value={idOffices || ''}
		onChange={e => onIdOfficesChange(e.target.value)}
	/>
}